import { EventEmitter, Input, Output } from '@angular/core';
import { SwitchOption } from '@app/common/components/switch/switch.component';

export interface PurchasePrice {
  priceType: string;
  priceUnit: string;
  otherSource: string;
  price: number | string;
}

export abstract class BulkPriceStepComponent {
  @Input() data: any;
  @Output() backCallback = new EventEmitter();
  @Output() submitCallback = new EventEmitter();

  priceTypeRental: SwitchOption[] = [
    {
      value: 'Cenový výměr ministerstva financí',
      id: 'F',
    },
    {
      value: 'Znalecký posudek',
      id: 'E',
    },
    {
      value: 'Jiný způsob',
      id: 'O',
    },
  ];

  priceTypePurchase: SwitchOption[] = [
    {
      value: 'Jiný způsob',
      id: 'O',
    },
  ];


  priceUnitRental: SwitchOption[] = [
    {
      value: 'Roční cena za metr čtvereční',
      id: 'A',
    },
    {
      value: 'Jednorázová cena',
      id: 'T',
    },
  ];

  priceUnitPurchase: SwitchOption[] = [
    {
      value: 'Cena pozemek',
      id: 'A',
    },
    {
      value: 'Cena za metr čtvereční pozemku',
      id: 'M',
    },
  ];
}
